import clsx from "clsx"

type GradientProps = {
    gradient: string;
    rounded?: string;
}

export default function GradientWrapper({ gradient, rounded }: GradientProps) {
    return (
        <span className={clsx("z-0 absolute inset-0 w-full h-full", gradient, rounded)} />
    )
}